import axios from "axios";
import { BetComponentState, PlayerLaunch } from "./types";

import { state } from "../system/state/AppState";

import 'rangeslider.js';
import $ from 'jquery';
import { App } from "@system/App";
import { multiplierFactor, nextRoundFactor } from "@system/Constants";
import { classicCrash, ClassicCrash } from "@system/ClassicCrash";
import { CrashRoyale, ImoonCrash, ImoonCrashBetMode, ModalButtonAction } from "@alien-game-server/sdk";
import * as Sentry from '@sentry/browser';
import { Layout } from "@system/Layout";
import { Icon } from "@game/Icon";










//get crashroyal token
export async function getLaunchToken(playerLaunch: PlayerLaunch): Promise<string | undefined> {
    // const url = 'https://alienapi.imoon.com/api/stage/v2/fun-launch';
    // const url = 'https://alienapi.imoon.com/api/test/v2/fun-launch'; //odl sdk
    const url = 'https://alienapi.imoon.com/api/stage/v2/fun-launch'; // new sdk

    const {
        playerId,
        gameId,
        nickname,
        currency,
        balance,
    } = playerLaunch;


    try {
        const data = JSON.stringify({
            playerId,
            gameId,
            nickname,
            currency,
            balance,
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        const apiRes = await axios.request(config);
        // console.log('respone', apiRes.data)


        if (!apiRes.data?.success) return;

        const launchUrl = apiRes.data?.url;

        const encodedToken = launchUrl.split('token=')[1].split('&')[0];
        const token = decodeURIComponent(encodedToken);


        return token;
    } catch (error) {
        console.error("token error", error)

        return undefined
    }

}


export const classicDomListeners = (classicCrash: ClassicCrash) => {
    const container = document.querySelector('#cashout-component > div')
    //INTERACTIVITY TABS
    const buttons = document.querySelectorAll('button[data-button]');
    const contentDivs = document.querySelectorAll('div[data-content]');

    buttons.forEach(button => {
        button.addEventListener('click', function () {

            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            // Hide all content divs and show only the related one
            const dataButton = button.getAttribute('data-button');
            contentDivs.forEach(div => {
                if (div.id !== `${dataButton}-content`) {
                    div.classList.add('hide');
                } else {
                    div.classList.remove('hide');
                }
            });
        });
    });

    //set interactivity buttons
    const activityBtn = document.getElementById('activity-button') as HTMLButtonElement
    activityBtn.addEventListener('click', async () => {

        await classicCrash.classicCrash.betButtonClicked()
    })


    //BET AMOUNT CHANGE
    const amount = document.getElementById('amount-value') as HTMLInputElement
    amount.autocomplete = 'off'

    amount.addEventListener('input', async (e) => {
        const value = (e.target as HTMLInputElement).value.replace(',', '')
        try {

            // console.log('@@@ bet amount value', value)
            await classicCrash.classicCrash.updateBetAmountByInput(value)
        } catch (error) {
            console.error('change bet amount', error)
        }

    })

    // CASHOUT CHANGE


    const cahsOutInout = $('#cashout-input') as any
    cahsOutInout.rangeslider({
        polyfill: false,
        // Default CSS classes
        rangeClass: 'rangeslider',
        disabledClass: 'rangeslider--disabled',
        horizontalClass: 'rangeslider--horizontal',
        verticalClass: 'rangeslider--vertical',
        fillClass: 'rangeslider__fill',
        handleClass: 'rangeslider__handle',

        // Callback function
        onInit: function () { },

        // Callback function
        onSlide: async function (position: any, value: any) {
            container?.classList.remove('inValid')

            classicCrash.classicCrash.updateAutoCashoutSlider(value)

        },

        // Callback function
        onSlideEnd: async function (position: any, value: any) {
            //   console.log("@@@SLIDE_END_VALUE",value)
            try {

            } catch (error) {
                // console.error('cashoutBets error', error)
            }
        }
    })
    $(document).on("mouseleave", () => {
        $('#cashout-input').trigger('mouseup');
        $('#cashout-input').trigger('touchend');
        $('#cashout-input').trigger('dragend');
    })



    const cashoutValueTextInput = document.getElementById('cashout-value') as HTMLInputElement
    cashoutValueTextInput.readOnly = true
    // cashoutValueTextInput.addEventListener('input', async (e) => {
    //     const value = (e.target as HTMLInputElement).value
    //     const sentValue = +value >= 20 ? '∞' : value
    //     // cashoutValueTextInput.value = +value >= 20 ? '∞' : `${value}`
    //     try {
    //         // await classicCrash.classicCrash.updateAutoCashoutOddsByInput(sentValue)
    //         await classicCrash.classicCrash.updateAutoCashoutSlider(+sentValue)

    //     } catch (error) {
    //         console.error('cashoutBets error', error)
    //     }
    // })

    cashoutValueTextInput.addEventListener('focus', () => {
        container?.classList.remove('inValid')
    })


    // double amount
    const doubleBtn = document.getElementById('double-btn') as HTMLButtonElement
    doubleBtn.addEventListener('click', async () => {
        await classicCrash.classicCrash.doubleBetAmount()
    })

    //halve amount
    const halveBtn = document.getElementById('halve-btn') as HTMLButtonElement
    halveBtn.addEventListener('click', async () => {
        await classicCrash.classicCrash.halveBetAmount()
    })




    //SEND MESSAGE
    const messageInput = document.getElementById('message-input') as HTMLInputElement
    messageInput.addEventListener('keydown', async e => {
        const message = messageInput.value
        if (e.key !== 'Enter' || !message.trim()) return
        e.preventDefault();
        await classicCrash.classicCrash.sendChatMessage(message)
        messageInput.value = ''

    })

    document.getElementById('message-button')?.addEventListener('click', async (e) => {
        const message = messageInput.value
        if (!message.trim()) return
        e.preventDefault();
        await classicCrash.classicCrash.sendChatMessage(message)
        messageInput.value = ''

    })

    //close notice tab in chat container
    const noticeDive = document.getElementById('notice') as HTMLDivElement
    const noticeButton = document.getElementById('notice-close') as HTMLButtonElement
    noticeButton.addEventListener('click', () => {
        //  console.log('notice closed')
        noticeDive.style.display = 'none'
    })


    //exit btn
    const exitBtn = document.getElementById('exit-btn') as HTMLButtonElement
    exitBtn.addEventListener('click', async () => {
        classicCrash.classicCrash.homeButtonClicked()
    })




    //    handle nickname
    const nicknameInput = document.getElementById('nickname-input') as HTMLInputElement
    const nicknameButton = document.getElementById('nickname-button') as HTMLButtonElement
    //activate deactivate Accept button 
    nicknameInput.addEventListener('input', () => {
        nicknameInput.value = nicknameInput.value.replace(/[^a-zA-Z0-9\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/g, '')
        const value = nicknameInput.value
        if (!value.trim()) {
            nicknameButton.classList.remove('active')
        } else {
            nicknameButton.classList.add('active')
        }
    })

    nicknameInput.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' && !!nicknameInput.value.trim()) {
            if (nicknameInput.value.length > 64) return
            classicCrash.classicCrash.setNickname(nicknameInput.value)
        }
    })

    nicknameButton.addEventListener('click', async () => {
        if (!!nicknameInput.value.trim()) {
            if (nicknameInput.value.length > 64) return
            classicCrash.classicCrash.setNickname(nicknameInput.value)
        }
    })


    //handle details 
    const detailsOverlay = document.getElementById('history-details-overlay') as HTMLDivElement

    const closeIcon = document.getElementById('details-close') as HTMLDivElement
    closeIcon.innerHTML = `${Icon.getSVG({ iconType: 'x', color: 'black', size: 20 }).outerHTML}`
    closeIcon.onclick = () => {

        detailsOverlay.classList.add('hide')
    }
    detailsOverlay.onclick = (event) => {
        // Close only if clicked on the overlay (not inside the modal)
        if (event.target === detailsOverlay) {
            detailsOverlay.classList.add('hide');
        }
    };




    document.addEventListener('click', (event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.id === 'details-overlay') {
            // your functionality here
            removeClassFromElement(document.body, 'rc')
        }
    });

    // details header
    const historyHeader = document.getElementById('history-content-header') as HTMLDivElement
    if (historyHeader) {
        historyHeader.innerHTML = `
        <span id ="history-header-title"></span>
        <span id="history-header-close">${Icon.getSVG({ iconType: 'x', color: 'black', size: 20 }).outerHTML}</span>
        `


        const closeIcon = historyHeader.querySelector("#history-header-close") as HTMLSpanElement
        closeIcon.onclick = () => removeClassFromElement(document.body, 'rc')
    }

}



export const domListeners = (crashRoyal: ImoonCrash) => {


    //INTERACTIVITY TABS
    const buttons = document.querySelectorAll('button[data-button]');
    const contentDivs = document.querySelectorAll('div[data-content]');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            // console.log('clicked')
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            // Hide all content divs and show only the related one
            const dataButton = button.getAttribute('data-button');
            contentDivs.forEach(div => {
                if (div.id !== `${dataButton}-content`) {
                    div.classList.add('hide');
                } else {
                    div.classList.remove('hide');
                }
            });
        });
    });



    //BET AMOUNT CHANGE
    const amount = document.getElementById('amount-value') as HTMLInputElement
    amount.addEventListener('input', async (e) => {
        const value = (e.target as HTMLInputElement).value.replace(',', '')
        try {
            if (isNaN(+value) || !value) {
                // console.log('@@@ NAN', value)
                amount.value = ''
                await crashRoyal.updateBetAmountByInput('0')
                return
            }
            // console.log('@@@ bet amount value', value)
            await crashRoyal.updateBetAmountByInput(value)
        } catch (error) {
            console.error('change bet amount', error)
        }

    })


    // CASHOUT CHANGE
    const container = document.querySelector('#cashout-component > div')

    const cahsOutInout = $('#cashout-input') as any
    cahsOutInout.rangeslider({
        polyfill: false,
        // Default CSS classes
        rangeClass: 'rangeslider',
        disabledClass: 'rangeslider--disabled',
        horizontalClass: 'rangeslider--horizontal',
        verticalClass: 'rangeslider--vertical',
        fillClass: 'rangeslider__fill',
        handleClass: 'rangeslider__handle',

        // Callback function
        onInit: function () { },

        // Callback function
        onSlide: async function (position: any, value: any) {
            container?.classList.remove('inValid')
            const cashoutValueTextInput = document.getElementById('cashout-value') as HTMLInputElement
            cashoutValueTextInput.value = +value >= 20 ? '∞' : Number(value).toFixed(2)


        },

        // Callback function
        onSlideEnd: async function (position: any, value: any) {
            try {
                let onSlideEndValue = value;
                if (value >= 20) {
                    onSlideEndValue = 1000
                }
                await crashRoyal.updateAutoCashoutSlider(onSlideEndValue)


            } catch (error) {
                console.error('cashoutBets error', error)
            }
        }
    })



    const cashoutValueTextInput = document.getElementById('cashout-value') as HTMLInputElement
    cashoutValueTextInput.addEventListener('input', async (e) => {
        const value = (e.target as HTMLInputElement).value

        cashoutValueTextInput.value = +value >= 20 ? '∞' : `${value}`

        try {
            await crashRoyal.updateAutoCashoutSlider(+value)

        } catch (error) {
            console.error('cashoutBets error', error)
        }
    })

    cashoutValueTextInput.addEventListener('focus', () => {
        container?.classList.remove('inValid')
    })



    //PLACE BET 

    const betBtn = document.getElementById('placebet-button') as HTMLButtonElement
    betBtn.addEventListener('click', async () => {
        //if value of cashout is not proper then prevent proceed
        if (!cashoutValueTextInput.value || +cashoutValueTextInput.value < 1.01 || +cashoutValueTextInput.value > 20) {
            container?.classList.add('inValid')
            return
        }
        //disable bet panel immediatelly
        document.getElementById('bet-component')?.classList.add('disabled')
        //change the text of bet button to placing bet... as pending
        betBtn.innerHTML = crashRoyal.translate('betPending')
        try {
            await crashRoyal.betButtonClicked()
        } catch (error) {
            // console.log('place bet error', error)
        }
    })



    //CANCEL BET
    const cancelBtn = document.getElementById('cancel-button') as HTMLButtonElement
    cancelBtn.addEventListener('click', async () => {
        cancelBtn.innerHTML = crashRoyal.translate('cancelPending')
        await crashRoyal.betButtonClicked()


    })

    //CASHOUT BTN
    document.getElementById('cashout-button')?.addEventListener('click', async () => {
        document.getElementById('cashout-placeholder')!.innerHTML = crashRoyal.translate('cashoutPending')
        // console.log("@@@ cashout clicked", new Date().toISOString())
        // await crashRoyal.cashoutBets({ cashouts: [{ index: 0, cashoutOdds: currentMultiplier }] })

    })






    //SEND MESSAGE
    const messageInput = document.getElementById('message-input') as HTMLInputElement
    messageInput.addEventListener('keydown', async e => {
        const message = messageInput.value
        if (e.key !== 'Enter' || !message.trim()) return
        e.preventDefault();
        await crashRoyal.sendChatMessage(message)
        messageInput.value = ''
    })

    document.getElementById('message-button')?.addEventListener('click', async (e) => {
        const message = messageInput.value
        if (!message.trim()) return
        e.preventDefault();
        await crashRoyal.sendChatMessage(message)
        messageInput.value = ''
    })

    //double bet amount 
    // const doubleBtn = document.getElementById('amount-x')
    // doubleBtn?.addEventListener('click', async () => {
    //     try {
    //         await crashRoyal.doubleBetAmount()
    //     } catch (error) {
    //         console.error("double bet amount", error)
    //     }
    // })


    //close notice tab in chat container
    const noticeDive = document.getElementById('notice') as HTMLDivElement
    const noticeButton = document.getElementById('notice-close') as HTMLButtonElement
    noticeButton.addEventListener('click', () => {
        // console.log('notice closed')
        noticeDive.style.display = 'none'
    })


    //handle nickname
    const nicknameInput = document.getElementById('nickname-input') as HTMLInputElement
    const nicknameButton = document.getElementById('nickname-button') as HTMLButtonElement
    //activate deactivate Accept button 
    nicknameInput.addEventListener('input', () => {
        const value = nicknameInput.value
        if (!value.trim()) {
            nicknameButton.classList.remove('active')
        } else {
            nicknameButton.classList.add('active')
        }
    })

    nicknameInput.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' && !!nicknameInput.value.trim()) {
            crashRoyal.setNickname(nicknameInput.value)
        }
    })

    nicknameButton.addEventListener('click', async () => {
        if (!!nicknameInput.value.trim()) {
            crashRoyal.setNickname(nicknameInput.value)
        }
    })


}




//GAME CONTROL BUTTONS
// const betComponent = document.getElementById('bet-component') as HTMLDivElement
// export const handleButtonsOnStart = async () => {
//     const cahsoutBtn = document.getElementById('cashout-button') as HTMLButtonElement
//     const betBtn = document.getElementById('placebet-button') as HTMLButtonElement
//     const cancelBtn = document.getElementById('cancel-button')
//     //if we have a bet then show cashout and hide other buttons
//     if (state.getState().currentBet) {
//         //turn curve to green 
//         state.setState({ ...state.getState(), isCurveGreen: true })
//         state.setState({ ...state, currentBet: false }) //reset current bet
//         // cahsoutBtn.classList.remove('hide')
//         // betBtn.classList.add('hide')
//         // cancelBtn?.classList.add('hide')

//         betComponent.setAttribute('data-state', BetComponentState.CASHOUT)
//         //if not bet then show place bet and hide cashout
//     } else {

//         betComponent.setAttribute('data-state', BetComponentState.PLACE_BET)
//         //set curve default color 
//         state.setState({ ...state.getState(), isCurveGreen: false })
//     }
// }



// export const handleButtonsOnCashoutResult = async () => {
//     const cahsoutBtn = document.getElementById('cashout-button') as HTMLButtonElement
//     const betBtn = document.getElementById('placebet-button') as HTMLButtonElement

//     //on cashout success show place bet and hide cahsout button
//     betComponent.setAttribute('data-state', BetComponentState.PLACE_BET)
//     // cahsoutBtn.classList.add('hide')
//     // betBtn.classList.remove('hide')

//     //reset curve color 
//     state.setState({ ...state.getState(), isCurveGreen: false })
// }


// export const handleOnCrashButtons = async () => {
//     // const cahsoutBtn = document.getElementById('cashout-button') as HTMLButtonElement
//     // const betBtn = document.getElementById('placebet-button') as HTMLButtonElement
//     // cahsoutBtn.classList.add('hide') //remove cahsout btn anyway

//     //reset curve color 
//     state.setState({ ...state.getState(), isCurveGreen: false })

//     if (!state.getState().currentBet) {
//         // betBtn.classList.remove('hide') //if we don't have current bet then show the place button
//         betComponent.setAttribute('data-state', BetComponentState.PLACE_BET)
//     } else {

//     }


// }


// export const handleOnWaitButtons = async () => {
//     //reset cancel btn to normal state instead of nextround
//     const cancelBtn = document.getElementById('cancel-button') as HTMLButtonElement
//     // cancelBtn.innerHTML = crashRoyal.crashClient.translateCrashClassic(TranslationsKey.btnCancel)
//     cancelBtn.classList.remove('nextround')

//     //reset curve color 
//     state.setState({ ...state.getState(), isCurveGreen: false })
// }


// export const onBetsResultsBtn = async () => {
//     //on auto cashout show placebet btn and hide cashout
//     const cahsoutBtn = document.getElementById('cashout-button') as HTMLButtonElement
//     const betBtn = document.getElementById('placebet-button') as HTMLButtonElement
//     betComponent.setAttribute('data-state', BetComponentState.PLACE_BET)
//     // cahsoutBtn.classList.add('hide')
//     // betBtn.classList.remove('hide')

//     //reset curve color 
//     state.setState({ ...state.getState(), isCurveGreen: false })
// }



//resizing 
const resizeControlComponent = () => {
    const app = document.getElementById('app') as HTMLDivElement
    const canvasBetWrapper = document.getElementById('canvas-bet-wrapper') as HTMLDivElement

    const appHeight = app.clientHeight
    const canvasBetWrapperHeight = canvasBetWrapper.clientHeight



    const controlHeight = `${appHeight - canvasBetWrapperHeight}px`
    const control = document.getElementById('control') as HTMLDivElement;


    // if (window.innerWidth >= 1000) {
    //     // Adjust the height based on available window height or any specific logic
    //     control.style.maxHeight = controlHeight
    //     control.style.height = '100%'


    // } else {
    //     control.style.minHeight = `${Math.max(appHeight - canvasBetWrapperHeight, 495)}px`;
    // }
}


const resizeNextRound = () => {
    const canvasComponent = document.querySelector('#canvas canvas') as HTMLCanvasElement
    const nextRound = document.getElementById('next-round') as HTMLDivElement
    const canvasWidth = canvasComponent.clientWidth
    const fontSize = canvasWidth / nextRoundFactor
    nextRound.style.fontSize = `${Math.round(fontSize)}px`
}


const resizeMultiplier = () => {
    const multiPlier = document.getElementById('multiplier') as HTMLDivElement
    const canvasComponent = document.querySelector('#canvas canvas') as HTMLCanvasElement

    const canvasWidth = canvasComponent.clientWidth
    const fontSize = canvasWidth / multiplierFactor
    multiPlier.style.fontSize = `${Math.round(fontSize)}px`
}


const resizeSVG = () => {
    const svg = document.getElementById("svg-element") as HTMLElement
    const width = App.app.renderer.width as number

    const startX = App.config.graphStartPoint.startX(App.app)
    const startY = App.config.graphStartPoint.startY(App.app)


    const svgWidth = width - startX
    const svgHeight = startY

    svg.style.width = `${svgWidth}px`
    svg.style.height = `${svgHeight}px`

    const bottom = App.app.renderer.height - startY
    svg.style.left = `${startX}px`
    svg.style.bottom = `${bottom}px`


}
//resize function 
export const resize = () => {
    Layout.resize();
    App.resize();
    //resize control component
    resizeControlComponent()
    //resize multiplier
    resizeMultiplier()
    //resize nextround 
    resizeNextRound()
    //resize SVG
    resizeSVG()




    if (window.innerWidth > 1000) {
        document.getElementById('players-content')?.classList.add('hide')
    } else {
        const playersTab = document.getElementById('players-tab') as HTMLButtonElement
        if (playersTab.classList.contains('active')) {
            document.getElementById('players-content')?.classList.remove('hide')
        }
    }

}



//helper functions 
export function extractNumber(value: string) {
    // Remove any non-numeric characters from the end of the string
    const numericValue = value.replace(/[^\d.]/g, '');

    // Convert the resulting string to a number
    return parseFloat(numericValue);
}


//debounce function 
function debounce(func: (...args: any[]) => void, delay: number) {
    let timeoutId: number | undefined;
    return (...args: any[]) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(() => {
            func(...args);
        }, delay);
    };
}


export function getBaseURL() {
    const baseUrl = process.env.LOCAL_BASE ?? ""
    try {
        const baseLocation = window.location;
        const origin = baseLocation.origin || (baseLocation.protocol + "//" + baseLocation.host);

        // Hardcoded string for localhost
        if (origin.includes("localhost") || origin.includes("127.0.0.1")) {
            return baseUrl;
        }

        return origin;

    } catch (e) {
        // Cross-origin iframe fallback
        const origin = window.location.origin || (window.location.protocol + "//" + window.location.host);

        if (origin.includes("localhost") || origin.includes("127.0.0.1")) {
            return baseUrl;
        }

        return origin;
    }
}

const theCanvas = document.getElementById('canvas') as HTMLDivElement
export const debouncedResize = debounce(() => {
    resize()
    theCanvas.style.opacity = '1'

}, 200)


export const disableScrollIos = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Disable smooth scroll on iOS
    if (isIOS) {
        document.documentElement.style.scrollBehavior = 'auto';
    }
}
export async function getDevPlayToken(gameId: string): Promise<string> {
    try {
        const url = process.env.DEV_URL ?? '';
        const urlParams = typeof window === 'undefined' ? undefined : new URLSearchParams(window.location.search ?? '');
        const nickname = urlParams?.get('nickname');

        const body = JSON.stringify({
            playerId: urlParams?.get('playerId') ?? Math.trunc(Math.random() * 10000000).toString(),
            gameId,
            ...(nickname && { nickname }),
            currency: urlParams?.get('currency') ?? 'USD',
            balance: +(urlParams?.get('balance') ?? '1000'),
            lang: urlParams?.get('lang') ?? urlParams?.get('language') ?? 'en',
        });

        const requestOptions: RequestInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body,
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {

            console.log('ERROR::Get Fun Play URL Error')
            return '';
        }

        const data = await response.json();

        const launchUrl = data?.url;

        const encodedToken = launchUrl.split('token=')[1].split('&')[0];
        const token = decodeURIComponent(encodedToken);

        return token;
    } catch (error) {
        console.log('ERROR::Get Fun Play URL Error')

        return ''
    }
}



const isStage = process.env.ENV_ID == "stage"
const isProd = process.env.ENV_ID == "prod"


export const addSentry = () => {
    const params = new URLSearchParams(window.location.search);
    const enableSentry = params.get('sentry') === 'true';

    if (enableSentry && process.env.SENTRY_SRC) {
        try {
            Sentry.init(isProd ? {
                dsn: process.env.SENTRY_SRC,
                integrations: [
                    Sentry.browserTracingIntegration(),
                ],
                // Tracing
                tracesSampleRate: 1.0,
            } :
                {
                    dsn: process.env.SENTRY_SRC,
                    integrations: [
                        Sentry.browserTracingIntegration(),
                        Sentry.browserProfilingIntegration()
                    ],
                    // Tracing
                    tracesSampleRate: 1.0,
                    profilesSampleRate: 1.0
                });
            console.log('✅ Sentry initialized');
            isStage && Sentry.captureMessage(`Game Launched`, "info");


            window.addEventListener("unhandledrejection", (event) => {
                // Send detailed info to Sentry
                Sentry.captureException(event.reason);

                // Optionally include extra context manually
                Sentry.addBreadcrumb({
                    category: "unhandledrejection",
                    message: event.reason?.message || String(event.reason),
                    data: {
                        stack: event.reason?.stack || null,
                        reason: event.reason,
                        promise: event.promise
                    },
                    level: "error"
                });
            });
        } catch (ex: any) {
            console.log('Sentry initializion Error');
        }
    } else {
        console.log('🚫 Sentry not initialized');
    }
}

export const LogError = (error: string) => {
    const params = new URLSearchParams(window.location.search);
    const enableSentry = params.get('sentry') === 'true';
    if (enableSentry && process.env.SENTRY_SRC) {
        Sentry.captureMessage(error, "warning")
    } else {
        console.warn(error)
    }
}


export function activateChat() {
    const chatContent = document.getElementById('chat-content') as HTMLDivElement
    const chatTab = document.getElementById('chat-tab') as HTMLButtonElement


    if (chatContent.classList.contains('hide')) {
        chatContent.classList.remove('hide')
    }

    if (chatTab.classList.contains('hide')) {
        chatTab.classList.remove('hide')
    }

    activateSection('chat')


}

export function hideSection(section: 'chat' | 'history' | 'players') {
    const button = document.querySelector(`button[data-button="${section}"]`);
    const content = document.getElementById(`${section}-content`);

    if (button) {
        button.classList.add('hide');
    }

    if (content) {
        content.classList.add('hide');
    }


}


export function activateSection(section: 'chat' | 'history' | 'players') {
    const buttons = document.querySelectorAll('button[data-button]');
    const contents = document.querySelectorAll('div[data-content]');

    buttons.forEach(btn => {
        const isTarget = btn.getAttribute('data-button') === section;
        btn.classList.toggle('active', isTarget);
    });

    contents.forEach(div => {
        const isTarget = div.id === `${section}-content`;
        div.classList.toggle('active', isTarget);
        div.classList.toggle('hide', !isTarget);
    });
}



export function getParameterByName(name: string) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
}
export function addClassToElement(element: HTMLElement | undefined, className: string) {
    if (!element) return;
    //if class not there add it
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    }
}

export function removeClassFromElement(element: HTMLElement, className: string) {
    if (!element) return;
    //remove class if found
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    }
}

export function showElement(element: HTMLElement) {
    removeClassFromElement(element, "hide")
}

export function hideElement(element: HTMLElement) {
    addClassToElement(element, "hide")
}


export function handleModalBtnsAction({ action, callback }: { action: any, callback?: () => void }) {
    switch (action) {
        case ModalButtonAction.CLOSE_MODAL: {
            callback!()
            // App.emitter.emit(App.config.events.OPEN_NICKNAME)
            const history = document.getElementById('interaction-component')
            if (history) {
                history.style.removeProperty("z-index")
            }
            const details = document.getElementById('details') as HTMLDivElement
            if (details) {
                details.style.removeProperty("z-index")
            }


            break;

            break;
        }
        case ModalButtonAction.DISCONNECT_GAME: {
            callback?.()
            App.sdk?.disconnect()

        }
        case ModalButtonAction.BACK_TO_HOME: {
            classicCrash.homeButtonClicked()
            break;
        }
        case ModalButtonAction.RELOAD_GAME: {
            classicCrash.classicCrash?.modalButtonClick(ModalButtonAction.RELOAD_GAME)
            callback?.()
            break;
        }

        case ModalButtonAction.RENEW_SESSION: {
            App.sdk?.renewSession()
            callback?.()
            break;
        }

        case ModalButtonAction.REDIRECT_TO_LOBBY: {
            classicCrash.lobbyButtonClicked()
            break;
        }


        default: {
            console.error('No such action')
        }
    }
}




 

  
 




export function isRunningInIframe(): boolean {
    let inIframe = false;
    try {
        inIframe = window.self !== window.top;
    } catch (e) {
        // Cross-origin access blocked
        inIframe = true;
    }
    return inIframe;
}
// Best to Sync Call from inside Click Handler to avoid popup blocker.
export function openHistoryUrl(historyUrl: string) {
    if (isRunningInIframe()) {
        try {
            const newTab = window.top?.open(historyUrl, '_blank',
                'noopener,noreferrer');
            if (newTab) {
                newTab.focus();
                return;
            }
        } catch {
            // Cross-Origin, CSP, or iframe Sandbox
        }
    }
    // Fallback: open from this frame
    const newTab = window.open(historyUrl, '_blank', 'noopener,noreferrer');
    if (newTab) {
        newTab.focus();
    }
}


export function getFileExtension(url: string): string | null {
    try {
        const pathname = new URL(url).pathname; // just the path part of the URL
        const lastSegment = pathname.split("/").pop() ?? "";
        const ext = lastSegment.includes(".") ? lastSegment.split(".").pop() : null;
        return ext ? ext.toLowerCase() : null;
    } catch {
        // fallback if input is not a full URL, just a filename
        const lastSegment = url.split("/").pop() ?? "";
        const ext = lastSegment.includes(".") ? lastSegment.split(".").pop() : null;
        return ext ? ext.toLowerCase() : null;
    }
}